function isEventWithTarget(value) {
  return value !== null && typeof value === 'object' && 'target' in value && typeof value.target === 'object' && value.target !== null && 'value' in value.target;
}
export function extractValue(eventOrValue) {
  if (isEventWithTarget(eventOrValue)) {
    return eventOrValue.target.value;
  }
  return eventOrValue;
}
//# sourceMappingURL=utils.js.map